import { render } from "./Sewage.vue?vue&type=template&id=1808350b&scoped=true"
import script from "./Sewage.vue?vue&type=script&lang=js"
export * from "./Sewage.vue?vue&type=script&lang=js"

import "./Sewage.vue?vue&type=style&index=0&id=1808350b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1808350b"]])

export default __exports__